import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import {
  EALL_TRACKS,
  MapViewResponse,
} from "../interfaces/search-location.interface";
import { TranslationService } from "src/app/shared/service/translation.service";
import { ERROR_CODES } from "../interfaces/error-codes";

@Injectable({
  providedIn: "root",
})
export class CircuitsServicesService {
  circuitData: any = {};
  trackData: any = {};
  public circuitContent = new BehaviorSubject<any>(this.circuitData);
  public shareCircuitData = this.circuitContent.asObservable();
  public trackContent = new BehaviorSubject<any>(this.trackData);
  public shareTrackData = this.trackContent.asObservable();
  public formContent = new Subject<any>();
  public shareformData = this.formContent.asObservable();
  public editActive = new Subject<any>();
  public shareEditActive = this.editActive.asObservable();
  public geocoordinates: any;
  public coordinatesLocation: any;

  public mediaValueForAnnotationSubject = new BehaviorSubject<any[]>([]);
  public mediaValueForAnnotation$ =
    this.mediaValueForAnnotationSubject.asObservable();

  public mediaValueForTrailCoverSubject = new BehaviorSubject<any>(null);
  public mediaValueForTrailCover$ =
    this.mediaValueForTrailCoverSubject.asObservable();
  highlightMediaList: any = [];
  public displayFleetManagement$ = new BehaviorSubject<boolean>(false);
  public displayFleetManagementObservable =
    this.displayFleetManagement$.asObservable();

  constructor(
    private readonly httpClient: HttpClient,
    private readonly _translationService: TranslationService,
  ) {}

  // Circuit Creation:- This is set for drawing polyline on map
  setCoordinateValue(data: any) {
    this.geocoordinates = data;
  }

  // Circuit Creation:- This is for getting the polyine
  getEditedCoordinates() {
    return this.geocoordinates;
  }

  setCoordinatesLocation(data: any) {
    this.coordinatesLocation = data;
  }

  getCoordinatesLocation() {
    return this.coordinatesLocation;
  }

  getLatestCircuitDetails(data: any) {
    this.circuitContent.next(data);
  }
  getLatestTrackDetails(data: any) {
    this.trackContent.next(data);
  }
  sendFormValue(value: any) {
    this.formContent.next(value);
  }
  getCircuitsList(pageSize: any, pageNo: any): Observable<any> {
    return this.httpClient.get("/api/getCircuitsList", {
      params: {
        size: pageSize,
        pageNumber: pageNo,
      },
    });
  }

  removeCircuits(guid: any): Observable<any> {
    return this.httpClient.delete("/api/deleteCircuits", {
      params: {
        guid: guid,
      },
    });
  }

  createCircuit(data: any): Observable<any> {
    return this.httpClient.put("/api/addCircuit", data);
  }

  updateCircuit(data: any): Observable<any> {
    return this.httpClient.put("/api/updateCircuit", data);
  }
  getCircuit(guid: any): Observable<any> {
    return this.httpClient.get("/api/getCircuit", {
      params: {
        guid: guid,
      },
    });
  }

  uploadTrack(data: any): Observable<any> {
    const formData = new FormData();
    formData.append("file", data);
    return this.httpClient.post("/api/trackUpload", formData);
  }
  searchCircuits(
    pageSize: any,
    pageNo: any,
    nameMatches: any,
  ): Observable<any> {
    return this.httpClient.get("/api/searchCircuits", {
      params: {
        size: pageSize,
        pageNumber: pageNo,
        nameMatches: nameMatches,
      },
    });
  }
  getMapCircuitList(limit: any, point: any, radius: any): Observable<any> {
    return this.httpClient.get("/api/mapViewCircuitList", {
      params: {
        limit: limit,
        point: point,
        radius: radius,
      },
    });
  }
  getTrackDetails(guid: any): Observable<any> {
    return this.httpClient.get("/api/getTrackDetails", {
      params: {
        guid: guid,
      },
    });
  }
  UpdateTrackDetails(userId: any, data: any): Observable<any> {
    return this.httpClient.put("/api/UpdateTrackDetails", data, {
      params: {
        userId: userId,
      },
    });
  }

  setHighlightMediaValue(data: any) {
    this.highlightMediaList.push(data);
  }

  getHighlightMediaValue() {
    return this.highlightMediaList;
  }

  setEditActiveStatus(value: boolean) {
    this.editActive.next(value);
  }

  sendMediaValueForCover(value: any[]) {
    this.mediaValueForAnnotationSubject.value.push(value);
  }

  sendMediaValueForAnnotations(value: any[]) {
    this.mediaValueForAnnotationSubject.next(value);
  }
  clearMediaValue() {
    this.mediaValueForAnnotationSubject.next([]);
  }

  sendCoverMediaValue(value: any) {
    this.mediaValueForTrailCoverSubject.next(value);
  }

  clearCoverMediaValue() {
    this.mediaValueForTrailCoverSubject.next(null);
  }

  public setSendTourToFleet(value: boolean) {
    this.displayFleetManagement$.next(value);
  }

  public getSendTourToFleet(): Observable<any> {
    return this.displayFleetManagement$.asObservable();
  }

  public handleSearchApiResponse(searchResults: MapViewResponse): any[] {
    console.log("searchResults :>> ", searchResults);
    return [
      ...searchResults.circuitInfoList,
      ...searchResults.emotionTourList,
      ...searchResults.offRoadTourList,
      ...searchResults.offRoadParkList,
    ];
  }

  public checkIsCircuits(type: string): boolean {
    const circuitList: string[] = [EALL_TRACKS.CIRCUIT, EALL_TRACKS.ALL];
    return circuitList.includes(type);
  }

  public checkIsEmotionTour(type: string): boolean {
    const emotionTourList: string[] = [
      EALL_TRACKS.EMOTION_TOUR,
      EALL_TRACKS.ALL,
    ];
    return emotionTourList.includes(type);
  }

  public checkIsOffroad(type: string): boolean {
    const offroadList: string[] = [
      EALL_TRACKS.OFF_ROAD,
      EALL_TRACKS.ALL,
      EALL_TRACKS.OFF_ROAD_PARK,
    ];
    return (
      offroadList.includes(type) &&
      this._translationService.featureFlags.locations.enableoffroadfeature
    );
  }

  public getToastErrMessagesBasedOnCode(error: any): string {
    let errorMsg = error;
    if (error?.error["error-code"]) {
      const code = error.error["error-code"];
      const errorCodes: any = ERROR_CODES;
      errorMsg = (code: string) =>
        errorCodes[code] || "BP_CM_SOMETHING_WENT_WRONG_MSG";
      return errorMsg(code);
    }
    return errorMsg;
  }
}
